package org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.upsert_products

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)